<nz-table #resultsTable nzBordered [nzData]="_data??[]" [nzBordered]="true" [nzSize]="'middle'" [nzLoading]="loading" [nzPageSize]="10" [nzFrontPagination]="true" class="mt-4">
	<thead>
		<tr>
			<th>Full Name</th>
			<th>ID Number</th>
			<th><span class="float-end">Create {{ticketMode}}</span></th>
		</tr>
	</thead>
	<tbody>
		<ng-container *ngFor="let wrapper of resultsTable.data">
			<tr>
				<td [(nzExpand)]="wrapper.expanded">{{ wrapper.payload.name }} {{ wrapper.payload.surname}}</td>
				<td>{{ wrapper.payload.idNumber }}</td>
				<td>
					<button nz-button nzType="primary" nzSize="small" *ngIf="!canCreateTicket(wrapper)" disabled class="float-end">Create {{ticketMode}}</button>
					<button nz-button nzType="primary" nzSize="small" *ngIf="canCreateTicket(wrapper)" (click)="startTicket(wrapper)" class="float-end">Create {{wrapper.setOfCheckedId.size}} {{ticketMode}}{{wrapper.setOfCheckedId.size>1?'s':''}}</button>
				</td>
			</tr>
			<tr *ngIf="wrapper.policies.length > 0 || wrapper.policies.length > 0" [nzExpand]="wrapper.expanded">
				<div class="ms-5">
					<nz-table #policyTable nzSize="small" [nzData]="wrapper.policies" [nzFrontPagination]="false">
						<thead>
							<tr>
								<th>Product</th>
								<th>Policy No</th>
								<th>Policy Alt</th>
								<th>Industry No</th>
								<th>Membership Number</th>
								<th>Last {{ticketMode}}</th>
								<th>Status</th>
								<th
									[nzChecked]="wrapper.checked"
									[nzIndeterminate]="wrapper.indeterminate"
									(nzCheckedChange)="onAllChecked(wrapper, $event)">
									Select All
								</th>
							</tr>
						</thead>
						<tbody><ng-container *ngFor="let item of policyTable.data">
								<tr>
									<td>{{item.payload.product?.name}} - {{item.payload.productOffer?.name}}</td>

									<td>{{item.payload.policyNumber}}</td>
									<td>{{item.payload.policyNumberAlt??'-'}}</td>
									<td>{{item.payload.policyNumberIndustry??'-'}}</td>
									<td>{{item.payload.policyNumberMembership??'-'}}</td>
									<td *ngIf="item.payload.latestTicketCreatedAt">
										<nz-tag [nzColor]="isRecent(item.payload.latestTicketCreatedAt) ? 'red' : 'default'">
											<span nz-icon nzType="clock-circle" nzTheme="outline" class="me-1"></span>
											{{ (item.payload.latestTicketCreatedAt | date) ?? 'None' }}
										</nz-tag>
									</td>
									<td *ngIf="!item.payload.latestTicketCreatedAt">
										<nz-tag [nzColor]="'green'">
											Never
										</nz-tag>
									</td>

									<td>{{item.payload.status}}</td>
									<td [nzChecked]="wrapper.setOfCheckedId.has(item.payload.id!)"
										(nzCheckedChange)="onItemChecked(wrapper, item, $event)">
										{{item.payload.workflowLabel}}
									</td>
								</tr>
							</ng-container>
						</tbody>
					</nz-table>
				</div>
			</tr>
		</ng-container>
	</tbody>
</nz-table>
